<script>
// @ts-nocheck

	import MainLayout from '../layouts/MainLayout.svelte';

	export let params = null;
</script>

<MainLayout layout_class="" developer_mode="false">
	<div class="loader fl">
		<p class="text-center m-0">Loading...</p>
		<div class="ms-3 loading" />
		{#if params && params.message}
			<p id="loadingmessage">Message is {params.message}</p>
		{/if}
	</div>
</MainLayout>
